import React, { useState } from "react";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

// page components
import Header from "./components/Header";
import Questions from "./components/Questions";
import Footer from "./components/Footer";
import Introduction from "./components/Introduction";
import Description from "./components/Description.jsx";

import data from "./components/data";
import Card from "./components/Card";
import createCard from "./components/createCard";
import { Badge } from "@material-ui/core";

//delete
import FilterTest from "./components/FilterTest";

// Notes
// Bootsrap for layout because less code it seems
// remember to change all "class" to "className"
// can either use id in css "#" or make yet another div...
//... yes, make another div, easier for custom components
// Material ui for components

// Need to add Gatsby for SEO. For next version?

// when the button is clicked, we could change the style
// of the button to one of the built in bootstrap ones like
// variant = "outlined" / "contained"

//!! don't need to send any data, just disable the button until all
// answers are clicked[x]..
// add the disabled variable and set it to the above logic
// can make disabled={false}...

// hide the questions when answers submitted [no]
// user have to refresh the page giving me better data
// need to scroll back to the top if we do this...
// don't like this, I want the user to read the result first

// submit should grey out again after use [x]
// then active again when a new option is clicked [x]
// all of the buttons to set submitted to false again
// then add submitted to the disabled conditional logic

// add the loading feature after submitted is clicked []

// still need to send data to answers to know which cards to render**[]
// Answers needs access to the answers stateful object from Questions.jsx
// then use filter to the info in data.js
// how?
//

// moved the answers component from app to Questions.jsx so sending the
// props for the answers state will be easier. child to parent
// replan []

export default function App() {
  // dont need this anymore because we don't need to send the map over here
  // function receiveData(resultText, resultTextType) {
  //   console.log("data...");
  //   console.log("received......" + resultText);
  //   console.log("received......" + resultTextType);
  //   setAnswersOne(resultText);
  //   setAnswersTwo(resultTextType);
  //   console.log(resultText);
  //   console.log(resultTextType);

  // this is Bad, fix and figure out how to filter
  // for (object of data) {
  //   if (object.type === "Shampoo") {
  //     console.log(object);
  //   }
  // }
  // }

  // console.log(data[0].type);
  // console.log(data);

  // the products aren't rendering, fix []

  // const [answersOne, setAnswersOne] = useState();
  // const [answersTwo, setAnswersTwo] = useState();

  return (
    <div className="App">
      <Header />
      {/* <Questions onSend={receiveData} /> */}
      <Introduction />
      <Questions />
      <Description />
      {/* Answers used to live here so might need to rename 
      Questions to Q&A or similar */}

      {/* {data.map(card => (
        <Card
          key={card.id}
          id={card.id}
          title={card.title}
          imgSrc={card.imgSrc}
          description={card.description}
          link={card.link}
        />
      ))} */}

      {/* {data.map(card => (
        <Card
          key={card.id}
          id={card.id}
          title={card.title}
          imgSrc={card.imgSrc}
          description={card.description}
          link={card.link}
        />
      ))} */}
      {/* <FilterTest /> */}
      <Footer />
    </div>
  );
}
